/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="76.1"
        height="108.38"
        viewBox="0 0 76.1 108.38"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M74.85 0a1.24 1.24 0 0 1 1.24 1.12v73.73A1.24 1.24 0 0 1 75 76.09H11.17a8.55 8.55 0 0 0-8.67 8.26v.31a8.7 8.7 0 0 0 8.41 8.41h13.7a1.252 1.252 0 1 1 .13 2.5H11.17A11.17 11.17 0 0 1 0 85V12.07A12.08 12.08 0 0 1 11.77 0ZM73.6 2.5H12.07a9.57 9.57 0 0 0-9.57 9.3v65.84l.12-.15a11.23 11.23 0 0 1 8.26-3.89H73.6ZM74.85 93.08a1.25 1.25 0 0 1 .15 2.49H38.51a1.25 1.25 0 0 1-.12-2.49Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M70.67 83.34a1.25 1.25 0 0 1 .12 2.49H38.51a1.25 1.25 0 0 1-.12-2.49ZM24.61 83.34a1.25 1.25 0 0 1 .13 2.49H10a1.25 1.25 0 0 1-.13-2.49ZM12.07 0a1.26 1.26 0 0 1 1.25 1.12v73.73a1.25 1.25 0 0 1-2.49.13V1.25A1.25 1.25 0 0 1 12.07 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M74 74a1.252 1.252 0 0 1 1.73 1.81 12.25 12.25 0 0 0-3.79 8.49v.44a12.59 12.59 0 0 0 3.55 8.49l.25.26A1.245 1.245 0 0 1 74 95.27a15.08 15.08 0 0 1-4.55-10.12v-1.29a14.78 14.78 0 0 1 4.27-9.59Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M38.38 80.64H24.73a1.25 1.25 0 0 0-1.25 1.25v25.36a1.24 1.24 0 0 0 2 .88l6.09-4.5 6.08 4.5a1.26 1.26 0 0 0 1.75-.25 1.27 1.27 0 0 0 .25-.75V81.89a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v21.51l-4.83-3.58-.11-.08a1.26 1.26 0 0 0-1.38.08L26 104.65V83.14Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M60.35 14.11H26.58a1.25 1.25 0 0 0-1.25 1.25v17.56a1.25 1.25 0 0 0 1.25 1.25h33.77a1.25 1.25 0 0 0 1.25-1.25V15.36a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v15.06H27.83V16.61Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'BookWithBookmarkIcon';

export default Icon;
